import sanityClient from '@sanity/client'

export default sanityClient({
  projectId: "l10q3sfg",
  dataset: "production",
  useCdn:true 
})